import React, { FC } from 'react';
import { FuelAvatar } from '@frete.com/fuel-react';
import { IAvatarProps } from './types';
import * as Styled from './styled';

const Avatar: FC<IAvatarProps> = ({ selfieUri, name }) => (
  <Styled.Wrapper>
    <FuelAvatar data-testid="avatar-person-trucker">
      <img slot="image" src={selfieUri} alt={`${name} avatar`} aria-label={`${name} avatar`} />
    </FuelAvatar>
  </Styled.Wrapper>
);

export default Avatar;
